import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsSpinnerSVGComponent } from './ts-spinner-svg.component';

@NgModule({
    declarations: [
        TsSpinnerSVGComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TsSpinnerSVGComponent
    ]
})
export class TsSpinnerSVGModule { }
